import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormattingPipe } from '../../detalle-inversion/pipes/formatting.pipe';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

declare var require: any;
import Highcharts from 'highcharts';
import Boost from 'highcharts/modules/boost';
import NoData from 'highcharts/modules/no-data-to-display';
import More from 'highcharts/highcharts-more';
import { SharedDataService } from '../services/shared-data.service';

Boost(Highcharts);
NoData(Highcharts);
More(Highcharts);

@Component({
  selector: 'app-chart-ganancia',
  standalone: true,
  imports: [FormattingPipe, MaterialModule, CommonModule],
  templateUrl: './chart-ganancia.component.html',
  styleUrl: './chart-ganancia.component.less'
})
export class ChartGananciaComponent implements AfterViewInit, OnInit {
  @Input() montoGanancia!: number;
  @Input() porcentajeGanancia!: string;
  @Input() title!: string;
  @Input() subtitle!: string;

  constructor(
    private sharedDataService: SharedDataService
  ) {}

  ngOnInit(): void {
    this.sharedDataService.simulacionData$.subscribe(data => {
      if (data) {
        this.processSimulacionData(data.investor_details);
      }
    });
  }


  ngAfterViewInit() {
    this.updateChart();
  }

  processSimulacionData(investorDetails: any) {
    if (investorDetails && investorDetails.length > 0) {
      const lastElement = investorDetails[investorDetails.length - 1];
      const simpliAmountLast = lastElement.simpli_amount || 0;
      const dapAmountLast = lastElement.dap_amount || 0;


      const ganancia = simpliAmountLast - dapAmountLast;
      const porcentajeGanancia = dapAmountLast !== 0 ? ((ganancia / dapAmountLast) * 100).toFixed(2) : '0.00';
  
      this.montoGanancia = ganancia;
      this.porcentajeGanancia = porcentajeGanancia;
  
      this.chartData = [
        { name: 'Simpli', y: simpliAmountLast },
        { name: 'DAP', y: dapAmountLast }
      ];
    } else {
      this.chartData = [
        { name: 'Simpli', y: 0 },
        { name: 'DAP', y: 0 }
      ];
    }
  
    this.updateChart();
  }
  

  updateChart() {
    if (this.options && this.chartData) {
      this.options.series = [
        {
          name: '',
          data: this.chartData.map((item) => ({
            y: item.y,
            color: item.name === 'Simpli' ? '#000467' : '#a5abd6',
          })),
        },
      ];
      Highcharts.chart('containerGanancia', this.options);
    }
  }

  chartData: { name: string, y: number }[] = [];

  options: any = {
    colors: [
      '#000467',
      '#a5abd6',
    ],
    chart: { type: 'bar',
      style: {
        fontFamily: 'DM Sans',
      },
    },
    credits: {
      enabled: false
    },
    title: { text: 'Ganancia al vencimiento' },
    xAxis: {
      categories: ['Simpli', 'DAP'],
      gridLineWidth: 0,
    },
    yAxis: {
      visible: false,
    },
    plotOptions: {
      series: {
        enableMouseTracking: false,
        dataLabels: {
          enabled: true,
          x: -10,
          formatter: function (this: any) {
            return '$' + Highcharts.numberFormat(this.y, 0, ',', '.');
          },
          inside: true,
          align: 'right',
          style: {
            color: 'white',
            textOutline: false,
            textShadow: '0px 0px 6px black',
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      formatter: function (this: any) {
        return (
          this.x + ': ' + ('$' + Highcharts.numberFormat(this.y, 0, ',', '.'))
        );
      },
      enabled: false,
    },
    series: [
      {
        name: '',
        data: [],
      },
    ],
  };


}
